import * as React from 'react';
import PropTypes from 'prop-types';
import { Tabs as MaterialTabs, Tab, Box } from '@mui/material';

function TabPanel(props: { children?: React.ReactNode; index: number; value: number }) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export interface iTab {
    label: string;
    tabPanel: React.ReactNode;
    tabProps?: {
        disabled?: boolean;
    };
}

export default function Tabs({
    tabs,
    defaultTab,
    onChange,
}: {
    tabs: iTab[];
    defaultTab?: number;
    onChange?: (tabIndex: number) => void;
}) {
    const [value, setValue] = React.useState<number>(defaultTab || 0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        if (onChange) onChange(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <MaterialTabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    {tabs.map((tab, index) => (
                        <Tab label={tab.label} {...a11yProps(index)} key={index} disabled={tab.tabProps?.disabled} />
                    ))}
                </MaterialTabs>
            </Box>
            {tabs.map((tab, index) => (
                <TabPanel value={value} index={index} key={index}>
                    {tab.tabPanel}
                </TabPanel>
            ))}
        </Box>
    );
}
